module.exports = __webpack_public_path__ + "static/img/GG.417e552d.svg";